module.exports = __webpack_public_path__ + "media/images/bg-interestedcontact-4df35e9ea03bf8f15e4cf57af9bf1f4f.jpg";